import { getInitialState, getPath } from "../../utils";

const initialState = {
  driverTagsList: [],
  prevPage: -1,
  nextPage: -1,
  currentPageTags: 1,
  activeFilters: {},
  activeDriverTag: {},
  driverTagsMappingList: [],
  prevPageMappings: -1,
  nextPageMappings: -1,
  currentPageTagsMapping: 1,
  activeFiltersDriverTagsMappings: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_DRIVER_TAGS_LIST":
      return setDriverTagsList(state, action);
    case "SET_ACTIVE_DRIVER_TAG":
      return setActiveDriverTag(state, action);
    case "SET_ACTIVE_FILTERS_DRIVER_TAGS":
      return setActiveFilters(state, action);
    case "SET_CURRENT_PAGE_DRIVER_TAGS":
      return setCurrentPageDriverTags(state, action);
    case "RESET_STATE_DRIVER_TAGS":
      return resetStateDriverTags(state, action);
    case "SET_DRIVER_TAGS_MAPPING_LIST":
      return setDriverTagsMappingList(state, action);
    case "SET_ACTIVE_FILTERS_DRIVER_TAGS_MAPPINGS":
      return setActiveFiltersMappings(state, action);
    case "SET_CURRENT_PAGE_DRIVER_TAGS_MAPPINGS":
      return setCurrentPageDriverTagsMappings(state, action);
    default:
      return state;
  }
}

const setCurrentPageDriverTags = (state, action) => {
  return {
    ...state,
    currentPageTags: action.payload,
  };
};

const setCurrentPageDriverTagsMappings = (state, action) => {
  return {
    ...state,
    currentPageTagsMapping: action.payload,
  };
};

const setDriverTagsList = (state, action) => {
  return {
    ...state,
    driverTagsList: getPath(action.payload, "data", []),
    prevPage: getPath(action.payload, "pageResponse.previousPage", -1),
    nextPage: getPath(action.payload, "pageResponse.nextPage", -1),
  };
};

const setDriverTagsMappingList = (state, action) => {
  return {
    ...state,
    driverTagsMappingList: getPath(action.payload, "data", []),
    prevPageMappings: getPath(action.payload, "pageResponse.previousPage", -1),
    nextPageMappings: getPath(action.payload, "pageResponse.nextPage", -1),
  };
};

const resetStateDriverTags = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};

const setActiveDriverTag = (state, action) => {
  return {
    ...state,
    activeDriverTag: getPath(action.payload, "tag", {}),
  };
};

const setActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};

const setActiveFiltersMappings = (state, action) => {
  return {
    ...state,
    activeFiltersDriverTagsMappings: action.payload,
  };
};
